import { render } from "./page-menu.vue?vue&type=template&id=de9f7272&scoped=true"
import script from "./page-menu.vue?vue&type=script&lang=js"
export * from "./page-menu.vue?vue&type=script&lang=js"

import "./page-menu.vue?vue&type=style&index=0&id=de9f7272&scoped=true&lang=less"
import "./page-menu.vue?vue&type=style&index=1&id=de9f7272&lang=less"
import "./page-menu.vue?vue&type=style&index=2&id=de9f7272&lang=css"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de9f7272"]])

export default __exports__